import React from 'react';
import { useTranslation } from 'react-i18next';
import { VideoEmbed } from '@guryou/html-components';
import { SystemModal } from 'components/shared';

import LocationModal from './LocationModal';
import WorkingHoursModal from './WorkingHoursModal';

const OnboardModals = () => {
  const { t } = useTranslation();

  return (
    <>
      <SystemModal id="setWorkingHours" width={800} title={t('ONBOARD.selectWorkingDays')} description={t('ONBOARD.selectWorkingDaysHours')}>
        <WorkingHoursModal />
      </SystemModal>
      <SystemModal id="setLocation" width={800} title={t('ONBOARD.location')} description={t('ONBOARD.selectLocation')}>
        <LocationModal />
      </SystemModal>
      {/* No static title here — dispatch(openModal('embedModal', { embedUrl }, modalTitle)) call sites
          (see PlayGuideVideoEmbed.js) pass the real per-video title as openModal's 3rd arg, and
          SystemModal prefers that over this title prop (same fallback SystemModal itself documents). */}
      <SystemModal id="embedModal" width={960}>
        <VideoEmbed />
      </SystemModal>
      {/* <Modal id="playVideo" maxWidth="md" title={'Video'} className={'padding-0'} titleClassName={classes.root}>
        <HtmlVideoPlayer />
      </Modal> */}
    </>
  );
};

export default OnboardModals;
